<template>
  <div class="return-money-detail">
    <el-form ref="returnForm" :model="returnForm" :rules="rules" label-width="120px">
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="现金" prop="cash">
                <el-input v-model="returnForm.cash" placeholder="¥ 0.00" autocomplete="off" style="width:220px" class="memMoney redFont"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="微信" prop="wechatpayMoney">
              <el-input v-model="returnForm.wechatpayMoney" autocomplete="off" placeholder="¥ 0.00" style="width:220px" class="memMoney"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="支付宝" prop="alipayMoney">
              <el-input v-model="returnForm.alipayMoney" autocomplete="off" placeholder="¥ 0.00" style="width:220px" class="memMoney"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="银行卡" prop="bankMoney">
              <el-input v-model="returnForm.bankMoney" autocomplete="off" placeholder="¥ 0.00" style="width:220px" class="memMoney"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="memInfo.type == 1">
          <el-row>
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="17">
              <el-form-item label="充值账户" prop="rechargeAccountMoney">
                <el-input v-model="returnForm.rechargeAccountMoney" autocomplete="off" placeholder="请输入金额" style="width:130px"></el-input>
                <span class="account">余额&nbsp;&nbsp;¥ {{memInfo.data.accountOffList&&memInfo.data.accountOffList[0] ? memInfo.data.accountOffList[0].rechargeOff.toFixed(2) : '0.00'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="17">
              <el-form-item label="赠送账户" prop="giftAccountMoney">
                <el-input v-model="returnForm.giftAccountMoney" autocomplete="off" placeholder="请输入金额" style="width:130px"></el-input>
                <span class="account">余额&nbsp;&nbsp;¥ {{memInfo.data.accountOffList&&memInfo.data.accountOffList[0] ? memInfo.data.accountOffList[0].giftOff.toFixed(2) : '0.00'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="17">
              <el-form-item label="返现账户" prop="returnMoney">
                <el-input v-model="returnForm.returnMoney" autocomplete="off" placeholder="请输入金额" style="width:130px"></el-input>
                <span class="account">余额&nbsp;&nbsp;¥ {{memInfo.data.accountOffList&&memInfo.data.accountOffList[0] ?　memInfo.data.accountOffList[0].backOff.toFixed(2): '0.00'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <el-row class="totalCash">
            <el-col :span="12">
                <p>应退<span>¥ {{memInfo.data.returntotal}}</span></p>
            </el-col>
            <el-col :span="12">
                <p>实退<span>¥ {{paidInAmount}}</span></p>
            </el-col>
        </el-row>
        <el-row class="dialogbtnOptions">
          <el-button class="darkBtn" @click="close">取消</el-button>
          <el-button class="redBtn" @click="confirmPay" :disabled="clickFalg">确定</el-button>
        </el-row>
    </el-form>
  </div>
</template>
<script>
import { refundAccountOff, refundSaleOrder } from '@/api'

export default {
  props: ['memInfo','dialogReturnType'],
  data() {
    // 价格
    const isvalidateMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > 999999.99) {
          callback(new Error("金额最大999999.99"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 价格小于余额
    const isvalidateRechargeMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > this.NumbertoFix(this.memInfo.data.accountOffList,1)) {
          callback(new Error("账户余额最大"+this.NumbertoFix(this.memInfo.data.accountOffList,1)));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const isvalidateGiftMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > this.NumbertoFix(this.memInfo.data.accountOffList,2)) {
          callback(new Error("账户余额最大"+this.NumbertoFix(this.memInfo.data.accountOffList,2)));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const isvalidateReturnMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > this.NumbertoFix(this.memInfo.data.accountOffList,3)) {
          callback(new Error("账户余额最大"+this.NumbertoFix(this.memInfo.data.accountOffList,3)));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      returnForm: {
        cash:'',
        wechatpayMoney: '',
        alipayMoney:'',
        bankMoney:'',
        rechargeAccountMoney:'',
        giftAccountMoney:'',
        returnMoney:'',
      },
      tableData:[],
      choosecurRow:[],
      rules: {
          cash:[
              { validator: isvalidateMoney, trigger: "blur" }
          ],
          wechatpayMoney:[
              { validator: isvalidateMoney, trigger: "blur" }
          ],
          alipayMoney:[
              { validator: isvalidateMoney, trigger: "blur" }
          ],
          bankMoney:[
              { validator: isvalidateMoney, trigger: "blur" }
          ],
          rechargeAccountMoney:[
            { validator: isvalidateRechargeMoney, trigger: "blur" }
          ],
          giftAccountMoney:[
            { validator: isvalidateGiftMoney, trigger: "blur" }
          ],
          returnMoney:[
            { validator: isvalidateReturnMoney, trigger: "blur" }
          ],
      },
      clickFalg:false,
    };
  },
  computed: {
    NumbertoFix(){
      return (val,type)=>{
        if(val && val[0]){
          return type == 1 ? val[0].rechargeOff : (type == 2 ? val[0].giftOff:(type == 3 ? val[0].backOff : 0))
        }else{
          return 0
        }
      }
    },
    paidInAmount(){
        let total = 0;
        total = Number(this.returnForm.cash) + Number(this.returnForm.wechatpayMoney) + Number(this.returnForm.alipayMoney) +　Number(this.returnForm.bankMoney) +　Number(this.returnForm.rechargeAccountMoney) + Number(this.returnForm.giftAccountMoney) + Number(this.returnForm.returnMoney);
        return total.toFixed(2);
    },
    computedMoney(){
      return (val)=>{
        let data = {};
        if(val){
          data.cash = Number(val.cash);
          if(this.memInfo.type == 1){
            // 退货退款
            data.orderId = this.memInfo.data.orderId;
            data.isChangeStock = this.memInfo.data.returnStock;
            data.shouldRefund = this.memInfo.data.returntotal;
            data.wechatpayMoney = Number(val.wechatpayMoney);
            data.alipayMoney = Number(val.alipayMoney);
            data.bankMoney = Number(val.bankMoney);
            data.rechargeAccountMoney = Number(val.rechargeAccountMoney);
            data.giftAccountMoney = Number(val.giftAccountMoney);
            data.returnMoney = Number(val.returnMoney);
            data.orderGoodsList = this.memInfo.data.chooseOrderGoodsList;
          }else{
            // 充值退款
            data.staffId = this.$store.state.userInfo.staffId;
            data.paidInAmount = Number(this.paidInAmount);
            data.wechatPay = Number(val.wechatpayMoney);
            data.aliPay = Number(val.alipayMoney);
            data.bankCard = Number(val.bankMoney);
            data.memberId = this.memInfo.data.memberId;
            data.remarks = this.memInfo.data.remarks;
          }
        }
        return data;
      }
    }
  },
  watch: {
    'dialogReturnType'(){
        this.clickFalg = false;
        this.$refs.returnForm.resetFields();
    }
  },
  methods: {
    confirmPay(){
      // 结算
      this.$refs.returnForm.validate(valid => {
          if (valid) {
              this.clickFalg = true;
              let post = this.computedMoney(this.returnForm);
              let pathurl = this.memInfo.type == 1 ? refundSaleOrder : refundAccountOff;
              pathurl(post).then(res=>{
                this.$message({
                  message: res.msg,
                  type: res.code == 1 ? 'success':'error'
                })
                if(res.code == 1){
                  this.$emit('successReturn',false);
                }
                this.$nextTick(()=>{
                  this.clickFalg = false;
                })
              })
          } else {
              this.clickFalg = false;
              console.log("error submit!!");
              return false;
          }
      })
    },
    close(){
        this.$emit('closeOpera',false);
        this.$refs.returnForm.resetFields();
    },
  }
};
</script>
<style lang="less" scoped>
.return-money-detail{
  .tableGoods {
    .myTitle {
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>

<style lang="less">
.dialog-return-type {
  width: 100%;
  overflow: hidden;
  text-align: center;
  .el-dialog__header{
    display: block;
  }
  .el-dialog__body{
    padding: 25px 0 30px;
  }
  .memMoney{
      &.redFont{
          .el-input__inner{color:#F83B56;}
      }
      .el-input__inner{
        color:#444;
        font-weight:bold;
        font-size:15px;
        text-align: right
      }
  }
  .seize {
    height: 20px;
  }
  .el-dialog__title {
    font-weight: bold;
  }
  .el-form-item {
    margin-bottom: 18px;
    .el-form-item__label{
        color: #999
    }
  }
  .el-form-item__content {
    text-align: left;
    .account{
        margin-left: 10px;
    }
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
    border-radius: 18px;
  }
  .el-button.redBtn {
    background: #F83B56;
    color: #fff;
  }
  .totalCash{
      height: 46px;
      line-height: 46px;
      background: #EFF1F5;
      text-align: center;
      p{
          color: #444;
          font-size: 15px;
          font-weight: bold;
          span{
              color:#F83B56;
              font-size: 19px;
              margin-left: 5px;
          }
      }
  }
  .el-button.darkBtn {
    background: #3b404f;
    color: #fff;
  }
  .dialogbtnOptions {
    margin-top: 26px;
    text-align: center;
    .el-button {
      min-width: 105px;
      height: 38px;
      border:none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/operatingFloor/returnMoneySum.vue